import React, { useState } from "react";
import MobileLogin from "./MobileLogin";
import InPlayScreen from "../Screen/exchange/member/InPlayScreen";
import { Link, useNavigate } from "react-router-dom";

const MobFooter = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [selectedId, setSelectedId] = useState(0)
  const [auth, setAuth] = useState(false)

  function handleButtonClick() {
    setShowLogin(true);
  }

  const footerContents = [
    {
      name:"home",
      src:"https://9wicket.pro/images/extra-icon/toolbar-icon-home.svg",
    },
    {
      name:"promotions",
      src:"https://9wicket.pro/images/extra-icon/toolbar-icon-promotion.svg",
    },
    {
      name:"deposite",
      src:"https://9wicket.pro/images/extra-icon/toolbar-icon-promotion.svg",
    },
    {
      name:"my account",
      src:"https://9wicket.pro/images/extra-icon/toolbar-icon-deposit.svg",
    },
  ]
  // return (
  //   <div className="hide_part_desktop before_element relative ">
  //     <img
  //       className="mt-3"
  //       src="	https://lc247.com/static/media/kv-virtual-cricket-m.14050138.jpg"
  //       alt=""
  //    />
  //     <div className="footer_part items-center flex bg-red-400 w-[100%]    fixed bottom-0 justify-between">
  //       <img src="./img/footergif.gif" className="w-[70px]" alt="" />

  //       <div className="flex flex-col items-center">
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="32"
  //           height="26"
  //           viewBox="0 0 32 26"
  //           className="w-[25px]"
  //         >
  //           <path
  //             fill="rgb(255,255,255)"
  //             fill-rule="nonzero"
  //             d="M31.57 1.78c-.4-.313-1.26-.65-4.092.065-.153.04-.303.078-.45.12.273-1.2.38-1.965.38-1.965H4.21s.102.72.358 1.857l-.046-.012C1.688 1.13.83 1.467.432 1.78c-.318.252-.47.627-.424 1.058.063.62.733 6.152 4.646 9.276 1.725 1.377 3.81 2.07 6.22 2.07h.032c.884.752 1.878 1.365 2.992 1.774v3.963h-3.32l-1.514 1.594V26h13.728v-4.486l-1.514-1.593H17.62v-3.925c1.16-.41 2.188-1.04 3.1-1.818.136.004.272.007.406.007 2.41 0 4.495-.693 6.22-2.07 3.913-3.124 4.583-8.656 4.646-9.276.045-.43-.106-.806-.423-1.057zM5.325 11.255c-3.564-2.845-4.18-7.956-4.24-8.53-.005-.05.002-.07 0-.07.006-.005.39-.423 2.99.21.268.063.532.133.786.204.74 2.823 2.204 7.004 4.857 9.954-1.676-.184-3.148-.773-4.394-1.768zm12.295.64c-.584.27-1.233.422-1.918.422-.64 0-1.25-.132-1.804-.37-1.66-.71-2.825-2.37-2.825-4.308 0-2.584 2.072-4.678 4.63-4.678 2.556 0 4.628 2.094 4.628 4.678 0 1.89-1.11 3.52-2.71 4.256zm13.294-9.17c-.06.574-.676 5.685-4.24 8.53-1.348 1.076-2.96 1.678-4.807 1.806 2.638-2.91 4.106-7.04 4.858-9.873.374-.11.782-.223 1.198-.324 2.606-.633 2.986-.212 2.99-.21 0 0 .006.02 0 .072z"
  //           />
  //         </svg>
  //         <Link to={"/cricket"} className="text-white   text_sm">
  //           sports
  //         </Link>
  //       </div>
  //       <div className="flex flex-col items-center">
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="20"
  //           height="21"
  //           className="w-[25px]"
  //         >
  //           <path
  //             d="M10 18.944c1.94 0 3.592-.718 4.953-2.154 1.362-1.436 2.042-3.165 2.042-5.189 0-2.023-.68-3.744-2.042-5.164-1.361-1.42-3.012-2.13-4.953-2.13-1.94 0-3.592.71-4.953 2.13-1.362 1.42-2.042 3.141-2.042 5.164 0 2.024.68 3.753 2.042 5.19 1.361 1.435 3.012 2.153 4.953 2.153zm0-16.741c2.504 0 4.632.922 6.385 2.766 1.753 1.843 2.63 4.054 2.63 6.632 0 2.579-.877 4.79-2.63 6.633C14.632 20.078 12.504 21 10 21s-4.632-.922-6.385-2.766C1.862 16.39.985 14.18.985 11.601c0-2.578.877-4.789 2.63-6.632C5.368 3.125 7.496 2.203 10 2.203zm.516 4.21v5.482l3.991 2.448-.751 1.272-4.742-2.937V6.413h1.502zM5.87 1.566L1.268 5.58 0 4.014 4.6 0 5.87 1.566zM20 4.014l-1.268 1.615-4.6-4.063L15.398 0 20 4.014z"
  //             fill="rgb(255,255,255)"
  //             fill-rule="evenodd"
  //           />
  //         </svg>
  //         {/* <img
  //           src="./img/mobile/a (1).png"
  //           className="w-[25px] rounded-[100%]"
  //           alt=""
  //         />
  //        */}
  //         <Link to={"/in-play"} className="text-white text_sm">
  //           {" "}
  //           In play
  //         </Link>
  //       </div>

  //       <div className="flex flex-col items-center">
  //         {/* <img
  //           src="./img/mobile/a (1).png"
  //           className="w-[25px] rounded-[100%]"
  //           alt=""
  //         /> */}
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="24"
  //           height="19"
  //           viewBox="0 0 24 19"
  //           className="w-[25px]"
  //           // style="&#10;    background: black;&#10;"
  //         >
  //           <path
  //             fill="rgb(255,255,255)"
  //             fill-rule="evenodd"
  //             d="M20.574 10.945v7.107c0 .52-.43.948-.952.948h-5.717v-5.686h-3.81V19H4.378c-.52 0-.952-.43-.952-.948v-7.107c0-.03.015-.06.015-.088L12 3.837l8.56 7.02c.014.03.014.06.014.088zm3.32-1.02l-.923 1.094c-.074.088-.193.148-.312.162h-.044c-.12 0-.224-.03-.313-.103L12 2.535 1.7 11.08c-.105.073-.224.117-.358.102-.12-.014-.238-.074-.313-.163L.105 9.923c-.163-.193-.134-.504.06-.666L10.87.388c.624-.518 1.636-.518 2.26 0l3.633 3.02V.523c0-.267.21-.474.477-.474h2.858c.268 0 .476.207.476.474v6.04l3.26 2.696c.194.162.223.473.06.666z"
  //           />
  //         </svg>
  //         <Link to={"/"} className="text-white text_sm">
  //           Home
  //         </Link>
  //       </div>

  //       <div className="flex flex-col items-center">
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="25"
  //           height="25"
  //           viewBox="0 0 25 25"
  //           className="w-[25px]"
  //           // style="&#10;    background: black;&#10;"
  //         >
  //           <path
  //             fill="rgb(255,255,255)"
  //             fill-rule="evenodd"
  //             d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm5.09-13.203c-.09 0-.18-.032-.27-.095-.49-.19-.802-.49-.936-.9L15.18 5.203v-.237c0-.253.222-.46.668-.617l.067-.048h.067c.536-.158.804-.426.804-.806 0-.443-.09-.72-.268-.83-.18-.11-.49-.166-.938-.166H9.42c-.447 0-.76.055-.938.166-.178.11-.268.387-.268.83 0 .38.268.648.804.806h.067l.067.048c.446.158.67.364.67.617v.237L8.615 10.8c-.134.412-.446.712-.937.902-.09.063-.18.095-.27.095-1.606.57-2.41 1.44-2.41 2.61 0 .378.067.64.2.78.135.144.403.215.804.215h5.425l.802 8.348h.536l.803-8.348h5.426c.4 0 .67-.063.803-.19.133-.126.2-.395.2-.806 0-1.17-.804-2.04-2.41-2.61z"
  //           />
  //         </svg>
  //         <p className="text_sm">Multi</p>
  //       </div>

  //       <div className="flex flex-col items-center">
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="20"
  //           height="20"
  //           viewBox="0 0 20 20"
  //           className="w-[25px]"
  //         >
  //           <path
  //             fill="rgb(255,255,255)"
  //             fill-rule="evenodd"
  //             d="M10 0c2.756 0 5.112.978 7.067 2.933C19.022 4.888 20 7.243 20 10c0 2.756-.978 5.112-2.933 7.067C15.112 19.022 12.757 20 10 20c-2.756 0-5.112-.978-7.067-2.933C.978 15.112 0 12.757 0 10c0-2.756.978-5.112 2.933-7.067C4.888.978 7.243 0 10 0zm0 19.183c2.82 0 5.16-1.106 7.02-3.318-1.38-.544-2.87-1.057-4.472-1.538-.096-.064-.144-.24-.144-.53 0-.223.112-.592.336-1.105.16-.32.305-.833.433-1.538.32-.385.545-.898.673-1.54.096-.576.096-1.024 0-1.345-.032-.033-.048-.065-.048-.097-.096-.32-.048-.93.144-1.827.16-.833-.08-1.667-.72-2.5-.61-.833-1.54-1.282-2.79-1.346h-.865c-1.25.096-2.18.545-2.788 1.346-.642.833-.883 1.667-.722 2.5.192.898.24 1.507.144 1.827v.096c-.128.384-.144.833-.048 1.345.16.673.384 1.202.673 1.587.128.64.272 1.138.433 1.49.128.257.192.64.192 1.154 0 .257-.048.417-.144.48-1.603.45-3.045.962-4.327 1.54 1.828 2.21 4.167 3.317 7.02 3.317z"
  //           />
  //         </svg>
  //         <p className="text_sm md-text-sm" onClick={handleButtonClick}>
  //           <MobileLogin type={"Account"} />
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // );
  
  const navigate = useNavigate()

  if(!auth){
    return <footer className=" fixed bottom-0 w-full">
      <div className=" flex w-full font-custom text-center ">
        <div className=" py-1 bg-[#d7e3f1] w-full flex gap-3 items-center justify-center">
          <div>
          <img src="/new_img/bdt.png" width={30} alt="" />
          </div>
          <div className=" text-[13px] ">
            <h2 className=" font-bold">BDT</h2>
            <p>English</p>
          </div>
        </div>
        <div onClick={()=>
          {setAuth(true)
          navigate("/signup")}
          } className=" py-2  w-full bg-[#ffdf1a]">
          <button className=" font-bold">Sign up</button>
        </div>
        <div onClick={()=>
          {
            setAuth(true)
            navigate("/login")
          }} className=" py-2 w-full bg-[#14805e]">
          <button className="font-bold text-[#d7e3f1]">Login</button>
        </div>
      </div>
    </footer>
  }

  return <footer className=" fixed bg-black py-2 bottom-0 w-full z-[999] border-t-[0.3px] border-gray-500">
      <div className=" footer-main flex justify-between items-center">
         {footerContents.map((content,idx)=><FooterContents key={idx} src={content.src} name={content.name} idx={idx} selectedId={selectedId} setSelectedId={setSelectedId} />)}
      </div>
  </footer>
  
};
export default MobFooter;

// Accounts
const FooterContents = ({src, name, idx, setSelectedId, selectedId})=>{
  return <div
  onClick={()=>{
    setSelectedId(idx)
  }}
  className={` ${selectedId === idx?" b-active ":""}relative flex flex-col justify-center w-full items-center `}> 
    <div className="">
       <img src={src} alt="" width={22} className=" " />
    </div>
    <div className=" capitalize text-xs text-white text-center">
      <h3>
        {name}
      </h3>
    </div> 
  </div>
}